import { apiV1 } from "@/store";

const state = {
  alerts: []
};

const actions = {
  getAllAlerts: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiV1.get(`/alerts`)
        .then((resp) => {
          commit("setAlerts", resp.data.alerts);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  submitAlert: ({ dispatch }, alert) => {
    return new Promise((resolve, reject) => {
      apiV1.post(`/alerts`, alert)
        .then((resp) => {
          dispatch("handleSuccess", "Alert added!");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  updateAlert: ({ dispatch }, alert) => {
    return new Promise((resolve, reject) => {
      apiV1.patch(`/alerts/${alert.alert_id}`, alert)
        .then((resp) => {
          dispatch("handleSuccess", "Alert updated!");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  },

  deleteAlert: ({ dispatch }, id) => {
    return new Promise((resolve, reject) => {
      apiV1.delete(`/alerts/${id}`)
        .then((resp) => {
          dispatch("handleSuccess", "Alert deleted.");
          resolve(resp);
        })
        .catch((err) => {
          dispatch("handleError", err);
          reject(err);
        });
    });
  }
};

const mutations = {
  setAlerts: (state, alerts) => {
    state.alerts = alerts;
  }
};

export default {
  state,
  actions,
  mutations
};
